import { v4 as uuidv4 } from 'uuid'
import { isEmpty } from './data_manipulator'

const WINDOWS_KB_IN_BYTES = 1024 // 1 MB in bytes
const UNIX_KB_IN_BYTES = 1e3 // 1 MB in bytes

export function getUUID(len: number | null = null) {
  if (len) return uuidv4().slice(0, len)
  return uuidv4()
}

export function getPercentage(value: number, total: number): number {
  if (!value || !total) return 0
  return +((value / total) * 100).toFixed(2)
}

export function stringToColor(str: string): string {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    // Create a hash code from the string
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  // Convert hash into an RGB hex code
  let color = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    color += ('00' + value.toString(16)).slice(-2)
  }
  return color
}

export function averageArray(arr: number[]): number {
  if (!arr || arr.length === 0) return 0
  const sum = arr.reduce((acc, val) => acc + val, 0)
  return +(sum / arr.length).toFixed(2)
}

export function getKeyValueorDefault<T>(obj: Record<string, T>, key: string, defaultValue: T): T {
  if (obj && Object.prototype.hasOwnProperty.call(obj, key)) {
    return obj[key]
  }
  return defaultValue
}

export function getKeyValueOrDefaultNested<T>(
  obj: any,
  key: string,
  defaultValue: T,
  callback?: (value: T) => T
): T {
  if (!obj || !key) return defaultValue

  const keys = key.split('.')
  let current: any = obj

  for (const k of keys) {
    if (current && typeof current === 'object' && k in current) {
      current = current[k]
    } else {
      return defaultValue
    }
  }

  return current !== undefined ? callback ? callback(current) : current : defaultValue
}

const getBytesPerKB = (): number => {
  return navigator.userAgent.includes('Windows') ? WINDOWS_KB_IN_BYTES : UNIX_KB_IN_BYTES
}

// export function BytesToSize(bytes: number, decimalPlaces: number = 2): string {
//   const bytesPerMB = getBytesPerMB()
//   if (bytes === 0) return '0 Bytes';
//   bytes = bytes - (bytes % bytesPerMB); // Round down to the nearest MB
//   const k = 1024;
//   const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
//   const i = Math.floor(Math.log(bytes) / Math.log(k));
//   return `${(bytes / bytesPerMB).toFixed(decimalPlaces)} ${sizes[i]}`;
// }

export function BytesToSize(
  bytes: number,
  decimalPlaces: number = 2,
  floorToBytes: boolean = false
): string {
  if (bytes === 0) return '0 Bytes'

  const bytesPerKB = getBytesPerKB()
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(bytesPerKB))
  let sizeInUnit
  if (floorToBytes) {
    sizeInUnit =
      i === 2 ? Math.floor(bytes / Math.pow(bytesPerKB, i)) : bytes / Math.pow(bytesPerKB, i)
  } else {
    sizeInUnit = bytes / Math.pow(bytesPerKB, i)
  }

  return `${sizeInUnit.toFixed(decimalPlaces)} ${sizes[i]}`
}

export function MBtoBytes(value: number, discrepancieValue = 0): number {
  const bytesPerKB = getBytesPerKB()
  return (value + discrepancieValue) * Math.pow(bytesPerKB, 2) // Convert MB to Bytes, added 0.49 MB allowance for file size discrepancies
}


export const valueOrDefault = (value: any, defaultValue: any) => {
  return isEmpty(value) ? defaultValue : value
}